var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacetedPrincess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "dia-faceted-princess",
    viewBox: "19 16 54 54",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    id: "bg-fill_32_",
    d: "M71.6 15.9H20.4c-.6 0-1.1.5-1.1 1.1v51.2c0 .6.5 1.1 1.1 1.1h51.2c.6 0 1.1-.5 1.1-1.1V17c.1-.6-.4-1.1-1.1-1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "shadow_32_",
    fill: "currentColor",
    fillOpacity: 0.085,
    d: "M37.1 51.7C25.7 40.3 20.5 23.6 19.3 19.2v49c0 .6.5 1.1 1.1 1.1h49.3c-3.7-.9-20.9-5.8-32.6-17.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "stroke_31_",
    fill: "currentColor",
    d: "M71.6 15.9H20.4c-.6 0-1.1.5-1.1 1.1v51.2c0 .6.5 1.1 1.1 1.1h51.2c.6 0 1.1-.5 1.1-1.1V17c.1-.6-.4-1.1-1.1-1.1zM46 67.1H22.6l5.5-3.7h35.8l5.5 3.7H46zm0-49h23.4l-5.5 3.7H28.1l-5.5-3.7H46zm0 44.7H30.1l15.2-4.3.6.1h.2l.6-.1 15.2 4.3H46zm0-40.4h15.9l-15.2 4.3-.6-.1H46h-.1l-.6.1-15.2-4.3H46zm13.4 6.8l1.4 13.4L59.4 56 46 57.4 32.6 56l-1.4-13.4 1.4-13.4L46 27.8l13.4 1.4zm-27.3-1.1l-3.4-5.5 15.1 4.3-11.7 1.2zm-1.8 12.3L26 25.3l5.5 3.4-1.2 11.7zm1.2 16.2L26 60l4.3-15.1 1.2 11.7zm.6.5l11.7 1.2-15.1 4.3 3.4-5.5zm27.8 0l3.4 5.5-15.1-4.3 11.7-1.2zm1.8-12.2L66 60l-5.5-3.4 1.2-11.7zm-1.2-16.2l5.5-3.4-4.3 15.1-1.2-11.7zm-.6-.6l-11.7-1.2 15.1-4.3-3.4 5.5zm-32-5.8l3.4 5.5-5.5-3.4-4.2-6.3V18h.1l6.2 4.3zm-2.1 20.3V26.7l4.3 15.2-.1.6v.2l.1.6-4.3 15.2V42.6zm-.1 18.2l5.5-3.4-3.4 5.5-6.3 4.2h-.1V67l4.3-6.2zm38.5 2.1l-3.4-5.5 5.5 3.4 4.2 6.3v.1h-.1l-6.2-4.3zm2-20.3v15.9l-4.3-15.2.1-.6v-.1-.1l-.1-.6 4.3-15.2v15.9zm.1-18.1l-5.5 3.4 3.4-5.5 6.3-4.2h.1v.1l-4.3 6.2zM21.5 42.6V19.2l3.7 5.5v35.8L21.5 66V42.6zm45.3 17.9V24.8l3.7-5.5V66l-3.7-5.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetedPrincess);
export default __webpack_public_path__ + "static/media/faceted-princess.2bc8612ed5e1494c6ddb477d72682041.svg";
export { ForwardRef as ReactComponent };